/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

 import * as Vue from 'vue-tsx-support';
 import { Component } from 'vue-property-decorator';
 import 'vue-tsx-support/enable-check';
 import { createBEM, createNamespace } from 'src/util/bem';
 import './biscreen.less';
 import EnmuCommunicationStatus from 'src/enums/enmuCommunicationStatus';
 import Switch from 'src/types/iview/Switch';
 import { getStationIcon } from 'src/components/stationTree/stationTree';
 import EnumStationType from 'src/enums/enumStationType';
 import EnumDeviceStatus from 'src/enums/enumDeviceStatus';
 import Bus, { Events } from 'src/util/bus';
 import PublicApi from 'src/util/publicApi';
 import json from 'src/assets/custom_map_config.json';
 
 let bem = createBEM('biscreen');
 
 export const MARK_SIZE = {
     width: 20, 
     height: 26,
 };
 @Component
 export default class Biscreen extends Vue.Component<any> {
     render(h) {
         return (
            <div class={bem()}>
                <iframe class={bem('iframe')} src="https://waterqm.com:5555/"></iframe>
            </div>
         );
     }
 }
 